module.exports = require("contentful");


//////////////////
// WEBPACK FOOTER
// external "contentful"
// module id = 275
// module chunks = 0